import { useCallback, useEffect, useState } from 'react';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';
import MoveTimesheetToJob from './MoveTimesheetToJob';
import ManageGroupHoliday from './ManageGroupHoliday';
import SwapContractChargeType from './SwapContractChargeType';
import GrantMultiTenantAccess from './GrantMultiTenantAccess';
import GrantAdminAccess from './GrantAdminAccess';
import AddChargeTypeToContracts from './AddChargeTypeToContracts';
import CopyTenantData from './CopyTenantData';
import DuplicateTimesheet from './DuplicateTimesheet';
import { MergeProjects } from './MergeProjects';
import ManageChargeQuestion from './ManageChargeQuestion';
import { getSupportToolRegistryItem } from './supportTools.registry';
import { SupportToolPage } from './SupportTools';
import ExportEmployeeTimesheets from './ExportEmployeeTimesheets';

export const AdminTools = ({ match }) => {
    const adminToolId = parseFloat(match.params.id);
    const [usageHistory, setUsageHistory] = useState([]);

    const refreshUsageHistory = useCallback(async () => {
        const history = await httpClient.js(ApiRoutes.adminTool.getAdminToolHistory(adminToolId));

        setUsageHistory(history);
    }, [adminToolId]);

    useEffect(() => {
        if (adminToolId) {
            void refreshUsageHistory();
        }
    }, [adminToolId, refreshUsageHistory]);

    const supportTool = getSupportToolRegistryItem(adminToolId, 'adminToolId');

    if (supportTool) {
        return (
            <SupportToolPage
                key={adminToolId}
                tool={supportTool}
                usageHistory={usageHistory}
                refreshUsageHistory={refreshUsageHistory}
            />
        );
    }

    let Component = 'div';

    switch (adminToolId) {
        case 1:
            Component = MoveTimesheetToJob;
            break;
        case 2:
            Component = ManageGroupHoliday;
            break;
        case 7:
            Component = SwapContractChargeType;
            break;
        case 12:
            Component = GrantMultiTenantAccess;
            break;
        case 13:
            Component = GrantAdminAccess;
            break;
        case 14:
            Component = AddChargeTypeToContracts;
            break;
        case 15:
            Component = CopyTenantData;
            break;
        case 16:
            Component = DuplicateTimesheet;
            break;
        case 17:
            Component = MergeProjects;
            break;
        case 18:
            Component = ManageChargeQuestion;
            break;
        case 21:
            Component = ExportEmployeeTimesheets;
            break;
        default:
            break;
    }

    return (
        <Component
            usageHistory={usageHistory}
            refreshUsageHistory={refreshUsageHistory}
            match={match}
        />
    );
};
